import Management from 'Management';
import React, { useEffect, useState } from 'react'
import API from 'API';
import { Skeleton } from 'antd';
import { useNavigate } from 'react-router-dom';


export default function Attendance() {
    const [grades, setGrades] = useState([]);
    const [gettingGrades, setGettingGrades] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        setGettingGrades(true);
        API.get("/grades")
        .then(res => {
            setGrades(res.data.results.map(item => ({
                value: item.id, label: `Khối ${item.grade}`
            })));
            setGettingGrades(false);
        })
        .catch(error => {
            console.log(error);
        })
    },[])

    const columns = [
        { title: "Tên lớp", dataIndex: "name", key: "name" },
        { title: "Khối", dataIndex: "grade", key: "grade" },
        { title: "Năm", dataIndex: "year", key: "year", render: item => `${item} - ${item+1}`},
    ]

    const layout = [
        [{ label: "Tên lớp", name: "name", type: "input", rules: [{ required: true }] }],
        [{ label: "Khối", name: "grade", type: "select", options: grades, rules: [{ required: true }] }],
    ]

    return gettingGrades ? <Skeleton active/> : <Management
        layout={layout}
        apiPath="/classes/"
        itemName="lớp"
        columns={columns}
        onTableClick={item => navigate(`/attendance/${item.id}`)}
        noChange={true}
    />
}
